// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"intl-relativetimeformat":"6afbe37423fea42c590d","vendors-node_modules_formatjs_intl-getcanonicallocales_polyfill_js-node_modules_formatjs_intl-64af64":"8a21d7205a7f1314fc7a","polyfills":"6accbdf2d54ae430d9b0"}[chunkId] + ".js";
};